const SELECTED_WORKSPACE_KEY = "selected_workspace_id";

function normalizeWorkspaceId(value) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function getDefaultStorage() {
  if (typeof localStorage === "undefined") return null;
  return localStorage;
}

function getDefaultApp() {
  if (typeof window === "undefined") return null;
  return window.APP || null;
}

export function getSelectedWorkspaceId(storage = getDefaultStorage()) {
  try {
    const value = storage?.getItem?.(SELECTED_WORKSPACE_KEY);
    return normalizeWorkspaceId(value);
  } catch (_) {
    return null;
  }
}

export function getActiveWorkspaceId(storage = getDefaultStorage(), app = getDefaultApp()) {
  const selectedWorkspaceId = getSelectedWorkspaceId(storage);
  if (selectedWorkspaceId) {
    return selectedWorkspaceId;
  }

  const fallbackWorkspaceId = app?.store?.state?.authUser?.last_workspace_id;
  return normalizeWorkspaceId(fallbackWorkspaceId);
}

export function requireWorkspaceUploadId(workspaceId) {
  const normalizedWorkspaceId = normalizeWorkspaceId(workspaceId);

  if (!normalizedWorkspaceId) {
    throw new Error("No workspace selected. Please select a workspace before uploading.");
  }

  return normalizedWorkspaceId;
}
